{
  "UPLOADER": {
    "NEW_IMPORT": "Nueva importación",
    "IMPORT_FINISHED": "Importación finalizada",
    "ERROR_SENDING_TASK": "Error creando la tarea",
    "IMPORT_BACKGROUND": "Importación en segundo plano",
    "IMPORT_XML": "Importar",
    "IMPORT_LIST": "Lista de importación"
  }
}